import { Form } from 'react-bootstrap';

import { VISAO_SGI_DOCS, type VisaoSistemaDoc } from '@/shared/constants/visao-sistema.constants';
import {
  NAVIGATION_VIEW_LABELS,
  NavigationView,
} from '@/shared/constants/navigation-view.enum';
import { useNavigationView } from '@/shared/hooks/useNavigationView';

const order: NavigationView[] = [
  NavigationView.Administrador,
  NavigationView.Corregedoria,
  NavigationView.Subcorregedoria,
  NavigationView.RecursosHumanos,
  NavigationView.Auxiliar,
  NavigationView.DefensorDiretor,
  NavigationView.Defensor,
  NavigationView.Estagiario,
  NavigationView.Colaborador,
];

function renderDoc(doc: VisaoSistemaDoc) {
  return (
    <>
      <p className="mb-2">{doc.descricao}</p>
      {doc.bullets?.length ? (
        <ul className="mb-0">
          {doc.bullets.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
      ) : null}
    </>
  );
}

export default function VisoesSistemaPanel() {
  const {
    effectiveView,
    inferredView,
    podeAlternarVisao,
    setNavigationViewOverride,
  } = useNavigationView();

  const selectValue =
    effectiveView != null && effectiveView !== inferredView
      ? String(effectiveView)
      : '';

  return (
    <div>
      {podeAlternarVisao && (
        <div className="card mb-4 border-warning">
          <div className="card-header bg-warning-subtle">Simular visão (testes)</div>
          <div className="card-body">
            <p className="small text-muted mb-3">
              Altera o menu lateral e as permissões exibidas nesta sessão, sem mudar o
              cadastro do usuário. Escolha &quot;Visão real&quot; para voltar ao comportamento
              normal.
            </p>
            <Form.Select
              id="config-simular-visao"
              aria-label="Simular visão do sistema"
              value={selectValue}
              onChange={(ev) => {
                const v = ev.target.value;
                setNavigationViewOverride(
                  v === '' ? undefined : (Number(v) as NavigationView),
                );
              }}
            >
              <option value="">
                Visão real (
                {inferredView != null
                  ? NAVIGATION_VIEW_LABELS[inferredView]
                  : 'carregando…'}
                )
              </option>
              {order.map((view) => (
                <option key={view} value={String(view)}>
                  {NAVIGATION_VIEW_LABELS[view]}
                </option>
              ))}
            </Form.Select>
          </div>
        </div>
      )}

      <p className="mb-4">
        As visões do SGI são fixas no código e direcionam o menu e as permissões.
        O fluxo de <strong>processo seletivo/candidaturas</strong> é público e não utiliza
        este enum.
      </p>

      {order.map((view) => {
        const doc = VISAO_SGI_DOCS[view];
        const label = NAVIGATION_VIEW_LABELS[view];
        return (
          <div key={view} className="mb-4">
            <h5 className="mb-2">{label}</h5>
            {renderDoc(doc)}
          </div>
        );
      })}
    </div>
  );
}
